import React from 'react';

const TabelaSdaContext = React.createContext();

export default TabelaSdaContext;
